"use client";
/**
 * useToast — thin adapter that delegates to Sonner.
 *
 * The rest of the codebase calls `toast({ title, description, variant })`
 * following the Radix/shadcn API. Sonner's mounted <Toaster /> in App.js
 * is what actually renders the toasts, so we translate the shadcn shape
 * into a Sonner call.
 */
import { toast as sonnerToast } from 'sonner';

const call = ({ title, description, variant, action, ...rest } = {}) => {
  const message = title ?? description ?? '';
  const opts = {
    description: title && description ? description : undefined,
    action,
    ...rest,
  };
  if (variant === 'destructive') {
    return sonnerToast.error(message, opts);
  }
  return sonnerToast(message, opts);
};

// Shadcn's `toast()` return shape used by some callers; keep minimal for safety.
const toast = (props) => {
  const id = call(props);
  return {
    id,
    dismiss: () => sonnerToast.dismiss(id),
    update: (next) => call({ ...props, ...next }),
  };
};

const useToast = () => ({
  toast,
  dismiss: (id) => sonnerToast.dismiss(id),
  toasts: [],
});

export { useToast, toast };
